/* This file is a copy of the existing file defined in the Settings app.           */
/* It displays OLDER API keys format. So, it is a temporary logic before creating  */
/* GKD API keys. */
export function propertiesToMap(properties) {
    if (!properties) {
        return {};
    }
    return properties.reduce((acc, { name, value }) => (Object.assign(Object.assign({}, acc), { [name]: value })), {});
}
